import { gateway } from '../../api';

const CORE = process.env.REACT_APP_CORE;

export function getTipoComissaoBordero() {
  return gateway.get(`${CORE}/tipos-comissao-bordero`);
}
